import {
  EHeadingStyleVariant,
  EIconButtonVariant,
  EModalVariants,
  GeneralCaretLeftIcon,
  Heading,
  IconButton,
  Modal,
} from '@outdoorsyco/bonfire';
import React from 'react';

import { useBreakpoint } from '@/hooks/useBreakpoint';
import { ESearchDropdownAlignment } from '@/hooks/useSearchDropdownAlignment';
import { ESearchWidgetFilter } from '@/services/analytics/search/types';

import { DesktopFilterContent } from './DesktopFilterContent';

export type TFilterContentSharedProps = {
  onBack?: () => void;
  isOpened: boolean;
  onDone?: () => void;
  onClose?: () => void;
  onTrackFilterToggled?: (
    oldSelection: Record<string, unknown>,
    newSelection: Record<string, unknown>,
    modifiedWidgetFilter: ESearchWidgetFilter,
  ) => void;
  buttonRef?: React.RefObject<HTMLDivElement>;
  searchBarRef?: React.RefObject<HTMLDivElement>;
  align: ESearchDropdownAlignment;
  useSearchBarWidth?: boolean;
};

type TFilterContentProps = TFilterContentSharedProps & {
  header: React.ReactNode;
  content: React.ReactNode;
  footerContent?: React.ReactNode;
};

export const FilterContent = ({
  onBack,
  header,
  content,
  footerContent,
  isOpened,
  onClose,
  ...props
}: TFilterContentProps) => {
  const { isAboveDesktop } = useBreakpoint();

  if (isAboveDesktop) {
    return (
      <DesktopFilterContent
        isOpened={isOpened}
        content={content}
        footerContent={footerContent}
        buttonRef={props.buttonRef}
        searchBarRef={props.searchBarRef}
        align={props.align}
        useSearchBarWidth={props.useSearchBarWidth}
      />
    );
  }
  return (
    <Modal isOpen={isOpened} variant={EModalVariants.Bottom} onClose={onClose || (() => {})}>
      <Modal.Header inlineHeader={true} className="flex items-center gap-2 !my-6">
        {onBack && (
          <IconButton
            icon={GeneralCaretLeftIcon}
            onClick={onBack}
            className="text-2xl"
            variant={EIconButtonVariant.Ghost}
          />
        )}
        <Heading variant={EHeadingStyleVariant.H6}>{header}</Heading>
      </Modal.Header>

      <Modal.Content className="flex-grow pb-6 mt-5">{content}</Modal.Content>

      {footerContent && <Modal.Footer className="p-0">{footerContent}</Modal.Footer>}
    </Modal>
  );
};
